var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"register-confirm"},[_c('div',{staticClass:"container"},[_c('Header',{attrs:{"title":_vm.userFastMsg.title,"text":_vm.userFastMsg.text}}),_c('CardMessage',{attrs:{"title":_vm.userFastMsg.titleMsg,"message":_vm.userFastMsg.message,"info":_vm.userFastMsg.info,"confirmIcon":_vm.userFastMsg.confirmIcon}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }